// Decides whether an entity drilldown renders the v2 drilldown (person, institution or funder subject) or the legacy
// EntityDrillDown body. Each subject kind has a strict opt-in flag; funders share the institution flag.

export const DRILLDOWN_FLAGS = {
  person: 'person_drilldown_v2',
  institution: 'institution_drilldown_v2',
  funder: 'institution_drilldown_v2',
};

// entityType -> subject kind. 'person' (author + inventor) and 'organization' (institution + assignee) are cross-type
// merges that only exist in v2.
const SUBJECT_KINDS = {
  author: 'person',
  inventor: 'person',
  person: 'person',
  institution: 'institution',
  organization: 'institution',
  funder: 'funder',
};
const CROSS_TYPE = ['person', 'organization'];

export function subjectKind(entityType) {
  return SUBJECT_KINDS[entityType] || null;
}

// A drilldown config's subject kind. Funders opened from grant data (source 'funding') carry grant-database ids, not
// the publication funder ids v2 covers, so they stay on the legacy view.
function configKind(config) {
  if (!config || (config.entityType === 'funder' && config.source === 'funding')) return null;
  return subjectKind(config.entityType);
}

// Strict opt-in: unlike featureEnabled(), a missing flag row means OFF so environments without the row keep the legacy drilldown
export function drilldownFlagOn(flags, kind) {
  return !!flags && flags[DRILLDOWN_FLAGS[kind]] === 'enabled';
}

// One entity or a merged view. Several ids without mergeMode is a partnership (documents where all co-occur), which
// only the legacy drilldown supports.
function singleOrMerged(config) {
  return config.entityId.length === 1 || !!config.mergeMode;
}

// True when the drilldown should render v2. `classic` is the user's "Classic view" preference, which cross-type merges
// ignore because they have no legacy view.
export function useDrilldownV2(config, flags, classic) {
  const kind = configKind(config);
  if (!kind || !drilldownFlagOn(flags, kind) || !singleOrMerged(config)) {
    return false;
  }
  return CROSS_TYPE.includes(config.entityType) || !classic;
}

// True when the "Classic view" switch should be offered for this drilldown
export function showClassicToggle(config, flags) {
  const kind = configKind(config);
  return (
    !!kind && drilldownFlagOn(flags, kind) && singleOrMerged(config) && !CROSS_TYPE.includes(config.entityType)
  );
}
